import axios from 'axios'
import router from '@/router'

const request = axios.create({
  baseURL: process.env.VUE_APP_TARGET_ADDRESS || 'http://localhost:8901',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
})

request.interceptors.request.use(config => {
  const token = window.localStorage.getItem('ecom_token')
  if (token && !config.skipAuth) config.headers.Authorization = `Bearer ${token}`
  delete config.skipAuth
  return config
})

request.interceptors.response.use(response => {
  let result = response.data
  if (typeof result === 'string') result = result ? JSON.parse(result) : {}
  if (result && result.success === false) {
    const error = new Error(result.errmsg || 'Request failed')
    error.code = String(result.errcode || '')
    if (error.code === '401') {
      window.localStorage.removeItem('ecom_token')
      window.localStorage.removeItem('ecom_user')
      if (router.currentRoute.path !== '/auth') router.push({ path: '/auth', query: { redirect: router.currentRoute.fullPath } })
    }
    return Promise.reject(error)
  }
  return result && Object.prototype.hasOwnProperty.call(result, 'content') ? result.content : result
}, error => Promise.reject(error))

export default request
